module.exports = __webpack_public_path__ + "static/media/no_image.31f5bb1d.jpg";